import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class SpecSheetDto{
    @ApiProperty()
    specSheetId:number;
     
    @ApiProperty()
    @IsNotEmpty({message:"CustomerId should not be empty"})
    customerId:number;

    @ApiProperty()
    @IsNotEmpty({message:"BrandId should not be empty"})
    brandId:number;

    @ApiProperty()
    @IsNotEmpty({message:"SkuCodeId should not be empty"})
    skuCodeId:number;

    @ApiProperty()
   @IsNotEmpty({message:"Should not be empty"})
   fileName:string;
   
   @ApiProperty()
   @IsNotEmpty({message:"Should not be empty"})
   filePath:string;

  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

  @ApiProperty({ type: 'file', format: 'binary' })
  file : string;

}